class ShippingEstimator extends HTMLElement {
  constructor() {
    super();
    this.countrySelect = this.querySelector('[data-country]');
    this.provinceSelect = this.querySelector('[data-province]');
    this.provinceContainer = this.querySelector('[data-province-container]');
    this.shippingMessage = this.querySelector('[data-shipping-message]');
    this.provinces = [];
    this.zipInput = this.querySelector('[data-zip]');
    this.submitButton = this.querySelector('[data-submit]');
    this.rates = null;
    this.updating = false;
    this.repeatTimer = null;
    if (
      !this.countrySelect ||
      !this.zipInput ||
      !this.provinceSelect ||
      !this.provinceContainer ||
      !this.submitButton ||
      !this.shippingMessage
    ) {
      console.error('Required markup not found.');
      return;
    }
    this.bind();
  }

  bind() {
    const estimator = this;
    this.countrySelect.addEventListener('change', function () {
      estimator.country = this.value;
      estimator.provinces = JSON.parse(
        estimator.countrySelect.options[estimator.countrySelect.selectedIndex].getAttribute('data-provinces')
      );
      if (estimator.provinces.length) {
        estimator.provinceContainer.classList.remove('hidden');
      } else {
        estimator.provinceContainer.classList.add('hidden');
      }
      estimator.generateProvinces();
    });
    this.provinceSelect.addEventListener('change', function () {
      estimator.province = this.value;
    });
    this.zipInput.addEventListener(
      'keyup',
      debounce((event) => {
        estimator.zip = event.target.value;
      }, 300).bind(this)
    );
    this.submitButton.addEventListener('click', function () {
      estimator.prepareResults();
    });
  }

  generateProvinces() {
    this.provinceSelect.textContent = null;
    if (!this.provinces) {
      this.province = '';
      const defaultOption = document.createElement('option');
      defaultOption.textContent = window.variantStrings.pleaseSelect;
      defaultOption.setAttribute('selected', true);
      this.provinceSelect.appendChild(defaultOption);
      return;
    }
    for (var x = 0; x < this.provinces.length; x++) {
      const option = document.createElement('option');
      option.value = this.provinces[x][0];
      option.textContent = this.provinces[x][1];
      if (x === 0) option.setAttribute('selected', true);
      this.provinceSelect.appendChild(option);
    }
    this.provinceSelect.dispatchEvent(new Event('change'));
  }

  prepareResults() {
    const estimator = this;
    if (this.updating) return;
    if (!this.zip || !this.country) return;
    this.shippingMessage.classList.add('hidden');
    this.setLoading();

    const postData = {
      shipping_address: {
        zip: this.zip,
        country: this.country,
        province: this.province
      }
    };

    fetch(window.Shopify.routes.root + 'cart/prepare_shipping_rates.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })
      .then((response) => response.json())
      .then((data) => {
        estimator.fetchResults(postData);
      })
      .catch((error) => {
        console.error(error);
        estimator.removeLoading();
      });
  }

  fetchResults(postData) {
    const estimator = this;
    clearTimeout(estimator.repeatTimer);
    fetch(window.Shopify.routes.root + `cart/async_shipping_rates.json`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data) {
          estimator.repeatTimer = setTimeout(() => {
            estimator.fetchResults(postData);
          }, 500);
          return;
        }
        if (data.shipping_rates && data.shipping_rates.length) {
          estimator.rates = data.shipping_rates[0];
          estimator.displayRate();
        } else {
          estimator.shippingMessage.textContent = window.variantStrings.shippingUnsupported;
          estimator.shippingMessage.classList.remove('hidden');
        }
        estimator.removeLoading();
      })
      .catch((error) => {
        console.error(error);
        clearTimeout(estimator.repeatTimer);
        estimator.removeLoading();
      });
  }

  displayRate() {
    if (this.rates.price && this.rates.name && this.rates.currency) {
      if (this.rates.price == '0.00') {
        this.shippingMessage.textContent = `${window.variantStrings.freeShipping} - ${this.rates.name}`;
      } else {
        this.shippingMessage.textContent = `${this.rates.currency} ${this.rates.price} - ${this.rates.name}`;
      }
    }
    this.shippingMessage.classList.remove('hidden');
  }

  setLoading() {
    this.updating = true;
    this.submitButton.classList.add('loading');
    this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  }

  removeLoading() {
    this.updating = false;
    this.submitButton.classList.remove('loading');
    this.submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
  }
}

customElements.define('shipping-estimator', ShippingEstimator);
